import { ChainID } from '@ankr.com/chains-list';
import { useCallback } from 'react';

import { chainsRoutesConfig } from 'domains/chains/routes';
import { setRedirectURL } from 'modules/auth/store/authSlice';
import { useAppDispatch } from 'store/useAppDispatch';
import { useSSOAuth } from 'modules/auth/hooks/useSSOAuth';
import { waitForLocalStorageSync } from 'modules/common/utils/waitForLocalStorageSync';

export interface IUseSignInHandlerProps {
  chainID: ChainID;
}

export const useSignInHandler = ({ chainID }: IUseSignInHandlerProps) => {
  const { handleSignIn } = useSSOAuth({
    hasAPIKeysNotification: true,
  });

  const dispatch = useAppDispatch();

  const chainPagePath = chainsRoutesConfig.chainDetails.generatePath(chainID);

  const signIn = useCallback(async () => {
    dispatch(setRedirectURL(chainPagePath));

    await waitForLocalStorageSync();

    handleSignIn();
  }, [chainPagePath, dispatch, handleSignIn]);

  return { signIn };
};
